var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"notificationList"},_vm._l((_vm.notifications),function(notif){return _c('NotificationCard',{key:notif.id,attrs:{"notification":notif}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }